import { DocumentsForUpload } from "app/utils/const";
import React from "react";
import { FormattedMessage } from "react-intl";
import "./IdentityDocumentChoice.scss";

type Props = {
  onDocumentSelect: (documentType: string) => void;
  onBackClick: () => void;
};

const IdentityDocumentChoice: React.FC<Props> = ({
  onDocumentSelect,
  onBackClick,
}) => {
  const handleDocumentClick = (documentType: string) => {
    onDocumentSelect(documentType);
  };

  return (
    <div className="identity-document-choice">
      <h2>
        <FormattedMessage
          id="account-verification-select-document-title"
          defaultMessage="Choose Document"
        />
      </h2>
      <div className="identity-document-choice__inner">
        <p>
          <FormattedMessage
            id="account-verification-select-document-question"
            defaultMessage="Which photo identification would you like to attach?"
          />
        </p>

        <button
          className="identity-document-choice__button"
          onClick={() => handleDocumentClick(DocumentsForUpload.PASSPORT)}
        >
          <FormattedMessage
            id="account-verification-select-document-passport"
            defaultMessage="Passport"
          />
        </button>
        <button
          className="identity-document-choice__button"
          onClick={() =>
            handleDocumentClick(DocumentsForUpload.DRIVING_LICENCE)
          }
        >
          <FormattedMessage
            id="account-verification-select-document-driving-license"
            defaultMessage="Full Driving Licence"
          />
        </button>
        <button
          className="identity-document-choice__button"
          onClick={() => handleDocumentClick(DocumentsForUpload.ID_CARD_FRONT)}
        >
          <FormattedMessage
            id="account-verification-select-document-id-card"
            defaultMessage="National Identification Card"
          />
        </button>
      </div>

      <button
        className="identity-document-choice__button identity-document-choice__button__back"
        onClick={onBackClick}
      >
        <FormattedMessage
          id="account-verification-select-document-back-button"
          defaultMessage="Back"
        />
      </button>
    </div>
  );
};

export default IdentityDocumentChoice;
